import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanFeePageUI from './LoanFeePageUI.js'

class LoanFeePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      //
      outOfPocketExpenses: null,
      grandTotals: {
        totalCharges: 0,
        totalChargesFormatted: "0.00",
        totalPaid: 0,
        totalPaidFormatted: "0.00",
        totalRemaining: 0,
        totalRemainingFormatted: "0.00"
      },
      //
      prepaymentFeeWaived: false,
      billProcessingFeeSubmitted: false,
      legalFeeSubmitted: false,
      pFStatusUpdated: false,
      pF2StatusUpdated: false,
      //
      uploadTDSMode1: false,
      uploadTDSMode2: false,
      uploadTDSSubmitted: false,
      uploadTDSSuccessMsg: null,
      uploadTDSErrorList1: [],
      uploadTDSErrorList2: [],
      //
      downloadSubmitted: false,
      //
      addMode: false,
      uploadSubmitted: false,
      //
      legalInvoiceUpdateMode: false,
      dateCreated: null,
      selectedCharge: null,
      invoiceNumber: '',
      alreadyPaid: false,
      //
      fileSubmitted: false,
      uploadSuccessMsg: null,
      uploadErrorList: [],
      //
      fileUploadSuccessMsg: null,
      fileErrorList: [],
    }
  }

  render() {
    return (
      <LoanFeePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        // Payment summary data
        outOfPocketExpenses={this.state.outOfPocketExpenses}
        grandTotals={this.state.grandTotals}
        //
        downloadSubmitted={this.state.downloadSubmitted}
        onDownloadClick1={this.onDownloadClick1}
        onDownloadClick2={this.onDownloadClick2}
        //
        prepaymentFeeWaived={this.state.prepaymentFeeWaived}
        onWaivePrepaymentFeeSubmitClick={() => { this.setState({ prepaymentFeeWaived: true }) }}
        onWaivePrepaymentFeeCancelClick={() => { this.setState({ prepaymentFeeWaived: false }) }}
        //
        billProcessingFeeSubmitted={this.state.billProcessingFeeSubmitted}
        onBillProcessingFeeSubmitClick={() => { this.setState({ billProcessingFeeSubmitted: true }) }}
        onBillProcessingFeeCancelClick={() => { this.setState({ billProcessingFeeSubmitted: false }) }}
        //
        legalFeeSubmitted={this.state.legalFeeSubmitted}
        onLegalFeeSubmitClick={() => { this.setState({ legalFeeSubmitted: true }) }}
        onLegalFeeCancelClick={() => { this.setState({ legalFeeSubmitted: false }) }}
        //
        pFStatusUpdated={this.state.pFStatusUpdated}
        onPFStatusUpdateClick={() => { this.setState({ pFStatusUpdated: true }) }}
        onPFStatusCancelClick={() => { this.setState({ pFStatusUpdated: false }) }}
        //
        pF2StatusUpdated={this.state.pF2StatusUpdated}
        onPF2StatusUpdateClick={() => { this.setState({ pF2StatusUpdated: true }) }}
        onPF2StatusCancelClick={() => { this.setState({ pF2StatusUpdated: false }) }}
        //
        onProcFeeClick={this.onProcFeeClick}
        procFeeMode={this.state.procFeeMode}
        //procFee=1
        uploadTDSMode1={this.state.uploadTDSMode1}
        onUploadTDSClick1={() => { this.setState({ uploadTDSMode1: true }) }}
        onUploadTDSCancelClick={() => { this.setState({ uploadTDSMode1: false, uploadTDSMode2: false }) }}
        onUploadTDSUpload1={this.onUploadTDSUpload1}
        uploadTDSErrorList1={this.state.uploadTDSErrorList1}
        //procFee=2
        uploadTDSMode2={this.state.uploadTDSMode2}
        onUploadTDSClick2={() => { this.setState({ uploadTDSMode2: true }) }}
        onUploadTDSUpload2={this.onUploadTDSUpload2}
        uploadTDSErrorList2={this.state.uploadTDSErrorList2}
        //
        addMode={this.state.addMode}
        onAddChargesClick={() => { this.setState({ addMode: true }) }}
        onCancelAddCharges={() => { this.setState({ addMode: false }) }}
        onDocsUpload={this.onDocsUpload}
        //
        dateCreated={this.state.dateCreated}
        selectedCharge={this.state.selectedCharge}
        invoiceNumber={this.state.invoiceNumber}
        alreadyPaid={this.state.alreadyPaid}
        legalInvoiceUpdateMode={this.state.legalInvoiceUpdateMode}
        onLegalInvoiceUpdateClick={this.onLegalInvoiceUpdateClick}
        onLegalInvoiceUpdateCancel={() => { this.setState({ legalInvoiceUpdateMode: false }) }}
        //
        uploadMode={this.state.uploadMode}
        onUploadClick={this.onUploadClick}
        onUploadCancelClick={() => { this.setState({ uploadMode: false }) }}
        onFileUpload={this.onFileUpload}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getOutOfPocketExpenses(context);
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getOutOfPocketExpenses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/charges`,
      cacheKey: CacheKeys.OutOfPocketExpenses(this.props.match.params.loanId),
      callback: this.getOutOfPocketExpensesCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context);
  }

  getOutOfPocketExpensesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      outOfPocketExpenses: response.loanChargeList,
    });
  };

  onUploadTDSUpload1 = (fileId, fileName, fileType, fileSize) => {
    this.setState({ uploadTDSSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.state.loan.loanId}/processingFees/1/tds/challan/validation`,
      this.onUploadTDSUpload1Callback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onUploadTDSUpload1Callback = (response) => {
    this.setState({ uploadTDSSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        uploadTDSErrorList1: errorList
      })
      return
    }

    this.setState({
      uploadTDSSuccessMsg: response.success,
      uploadTDSErrorList1: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadTDSSuccessMsg: null
        })
      }, 2000)
    }
  }

  onUploadTDSUpload2 = (fileId, fileName, fileType, fileSize) => {
    this.setState({ uploadTDSSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.state.loan.loanId}/processingFees/2/tds/challan/validation`,
      this.onUploadTDSUpload2Callback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onUploadTDSUpload2Callback = (response) => {
    this.setState({ uploadTDSSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        uploadTDSErrorList2: errorList
      })
      return
    }

    this.setState({
      uploadTDSSuccessMsg: response.success,
      uploadTDSErrorList2: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadTDSSuccessMsg: null
        })
      }, 2000)
    }
  }

  onDownloadClick1 = (event) => {
    this.setState({ downloadSubmitted: true })

    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.state.loan.loanId}/processingFees/1/tds/challan/fileDownloadSignedUrl`,
      this.onDownloadClick1Callback, null, null
    )
  }

  onDownloadClick1Callback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadClick2 = (event) => {
    this.setState({ downloadSubmitted: true })

    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.state.loan.loanId}/processingFees/2/tds/challan/fileDownloadSignedUrl`,
      this.onDownloadClick2Callback, null, null
    )
  }

  onDownloadClick2Callback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onLegalInvoiceUpdateClick = (event, chargeData) => {
    let dateCreated = event.currentTarget.getAttribute('date-created');
    let invoiceNumber = event.currentTarget.getAttribute('data-invoice-number');
    let alreadyPaid = chargeData && chargeData.paymentList && chargeData.paymentList.length > 0;

    console.log("selected date Created", dateCreated);
    console.log("invoice number:", invoiceNumber);
    console.log("already paid:", alreadyPaid);

    this.setState({ legalInvoiceUpdateMode: true, selectedCharge: chargeData, invoiceNumber: invoiceNumber, dateCreated: dateCreated, alreadyPaid: alreadyPaid });
  }

  onUploadClick = (event) => {
    let invoiceNumber = event.currentTarget.getAttribute('data-invoice-number');
    console.log("invoice number:", invoiceNumber);
    this.setState({ uploadMode: true, invoiceNumber: invoiceNumber });
  }

  onDocsUpload = (fileId, fileName, fileType, fileSize, invoiceNumber, invoiceDateISO, chargeAmount, remarks, dueDateISO) => {
    this.setState({
      uploadSubmitted: true,
      uploadSuccessMsg: null,
      uploadErrorList: [],
    });

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/legalChargeInvoice/validation`,
      this.onDocsUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      },
      invoiceNumber: invoiceNumber,
      invoiceDateISO: invoiceDateISO,
      chargeAmountF: chargeAmount,
      remarks: remarks,
      dueDateISO: dueDateISO
    });
  }

  onDocsUploadCallback = (response) => {
    this.setState({ uploadSubmitted: false });
    let errorList = [];
    response.errorList.forEach(error => {
      errorList.push(error.message);
    });

    this.setState({
      uploadSuccessMsg: response.success,
      uploadErrorList: errorList,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadSuccessMsg: null
        });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  }

  onFileUpload = (fileId, fileName, fileType, fileSize) => {
    let invoiceId = this.state.invoiceNumber;
    if (!invoiceId || (typeof invoiceId === 'string' && invoiceId.trim() === '')) {
      alert('Please update invoice details before uploading invoice');
      return;
    }
    // console.log("invoice id:", invoiceId);
    this.setState({
      fileSubmitted: true,
      fileUploadSuccessMsg: null,
      fileErrorList: [],
    });

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/charges/${invoiceId}/legalChargeInvoice/validation`,
      this.onFileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    });
  }

  onFileUploadCallback = (response) => {
    this.setState({ fileSubmitted: false });
    let errorList = [];
    response.errorList.forEach(error => {
      errorList.push(error.message);
    });

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileErrorList: errorList,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null
        });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.state.loan.loanId))
    CacheManager.removeObject(CacheKeys.OutOfPocketExpenses(this.state.loan.loanId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getOutOfPocketExpenses(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getOutOfPocketExpenses(context)
    }
  }
}

export default withRouter(LoanFeePageSF)


